import { z } from "zod";
import { CategoryTypesEnum } from "./category-statics";
import { zStringId } from "../../utils";

export const zCategory = z.object({
  _id: zStringId(),
  name: z.string(),
  type: z.nativeEnum(CategoryTypesEnum),
  icon: z.string().optional(),
});

export const zSubcategory = z.object({
  _id: zStringId(),
  name: z.string(),
  icon: z.string().optional(),
  description: z.string().optional(),
});
